import {SubmitHandler} from 'react-hook-form';
import {NextPage} from 'next';
import {useRouter} from 'next/router';

import {Screen} from '#component/base';
import {ForgotPasswordForm} from '#component/form';
import {AuthCTAMessages} from '#component/partial';
import {withRequireUserState} from '#component/util/RequireUserState/RequireUserState';
import {useAuth, useToastQueue} from '#hook';
import {sprinkles} from '#style/sprinkles';

export const ForgotPasswordScreen = () => {
  const {forgotPassword} = useAuth();
  const {addToast} = useToastQueue();
  const router = useRouter();

  const {return_to: returnUrl} = router.query;

  const handleSubmit: SubmitHandler<{email: string}> = async ({email}) => {
    try {
      await forgotPassword({email, returnUrl: returnUrl as string});
    } catch (error) {
      throw new Error(`An unexpected error occured: ${error}`);
    } finally {
      addToast({
        children: 'If you have an active account, you will receive an email with instructions.',
      });
    }
  };

  return (
    <Screen
      contentContainerClassName={sprinkles({
        flex: 'flex',
        content: ['end', 'end', 'center'],
        dir: 'col',
      })}
      pageName="Recover Password"
      sidePanelImageUrl="/image/recover-password.jpg">
      <div
        className={sprinkles({
          direction: 'col',
          flex: 'flex',
          height: 'full',
          placeContent: ['end', 'center'],
        })}>
        <AuthCTAMessages
          title="Forgot your Password?"
          messages={[
            'Enter the email address associated with your account and we’ll send you instructions to reset your password.',
          ]}
        />
        <ForgotPasswordForm onSubmit={handleSubmit} />
      </div>
    </Screen>
  );
};

export const ForgotPassword: NextPage = withRequireUserState(ForgotPasswordScreen, {
  userState: 'anonymous',
});
